import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_private/_route/_internal/people/$identityId/_candidate/suggested-pipelines/',
)({});
